/*
  +-------------------------------------------------------------+
  !     CODE SOURCE MATERIALS                                   !
  !     OUESTADAM CONFIDENTIAL                                  !
  !                                                             !
  !     WWW.OUESTADAM.COM Web App Code                          !
  !     (C) COPYRIGHT OUESTADAM 2024                            !
  !     Licensed Internal Code - Property of OUESTADAM          !
  +-------------------------------------------------------------+
  +-------------------------------------------------------------+
  !                                                             !
  !  File  : wwwDef.js                                          !
  !  Desc. : www.ouestadam.com Definitions file                 !
  !                                                             !
  !  Author: D.ESTEVE                                           !
  !  Modif.: 01/12/2024                                         !
  +-------------------------------------------------------------+
*/
/*=============== Exported definitions =========================*/
/*
--- Modals list
*/
export const wwwDefModal_e = {
    noModal: 0,
};

/*
--- Window orientation
*/
export const wwwDefOrientation = {
    landscape: 0,
    portrait: 1
}

/*
--- Device type
*/
export const wwwDefDevice = {
    desktop: 0,
    tablet: 1,
    mobile: 2
}

/*
--- URL Paths
*/
export const wwwDefUrl = {
    main: "",
    freeware: "freeware"
}

/*
--- Web page type
*/
export const wwwDefPageType = {
    cv: 0,
    freeware: 1
}
